import React from 'react';
import Log from '@deephaven/log';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
var log = Log.module('PluginTableOptionsErrorBoundary');
/**
 * Tiny error boundary scoped to a single plugin-supplied sidebar page.
 * If the plugin's `configPage` throws during render, we log the error
 * once and render a minimal fallback ("<name> failed to render:" + the
 * thrown message) rather than tearing down the entire `IrisGrid`
 * subtree or leaving a blank panel. Used only by the page-switch
 * `default` case in `IrisGrid.tsx`.
 */
export default class PluginTableOptionsErrorBoundary extends React.Component {
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }
  componentDidCatch(error, info) {
    var itemType = this.props.itemType;
    log.error("Plugin sidebar page \"".concat(itemType, "\" threw during render; suppressing."), error, info);
  }
  render() {
    var error = this.state.error;
    var _this$props = this.props,
      children = _this$props.children,
      itemType = _this$props.itemType;
    if (error == null) {
      return children;
    }
    return /*#__PURE__*/_jsxs("div", {
      className: "plugin-sidebar-error",
      role: "alert",
      "data-testid": "plugin-sidebar-error",
      children: [/*#__PURE__*/_jsxs("p", {
        children: [itemType, " failed to render:"]
      }), /*#__PURE__*/_jsx("p", {
        children: error.message
      })]
    });
  }
}
//# sourceMappingURL=PluginTableOptionsErrorBoundary.js.map